import talentPool from './talent-pool'
import wishlist from './wishlist'

export default [
  ...talentPool, ...wishlist,
]
